// Weekly streak that resets every Saturday at 22:00 (10pm) for everyone.

export function weekStart(now = new Date()) {
  const d = new Date(now);
  const day = d.getDay(); // 0 Sun .. 6 Sat
  const diff = (day - 6 + 7) % 7; // days since last Saturday
  const start = new Date(d);
  start.setDate(d.getDate() - diff);
  start.setHours(22, 0, 0, 0);
  if (start > now) start.setDate(start.getDate() - 7);
  return start;
}

export function nextReset(now = new Date()) {
  const start = weekStart(now);
  const next = new Date(start);
  next.setDate(start.getDate() + 7);
  return next;
}

export function weeklyCount(history = []) {
  const start = weekStart();
  return history.filter((h) => new Date(h.date) >= start).length;
}

export const STREAK_TIERS = [
  { count: 3, id: "streak3", emoji: "🔥", name: "On Fire" },
  { count: 5, id: "streak5", emoji: "⚡", name: "Hot Streak" },
  { count: 10, id: "streak10", emoji: "👑", name: "Quiz Machine" },
];

export function nextTier(count) {
  return STREAK_TIERS.find((t) => count < t.count) || null;
}

export function resetLabel(now = new Date()) {
  const next = nextReset(now);
  const ms = next - now;
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  if (days > 0) return `Resets in ${days}d ${hours}h`;
  const mins = Math.floor((ms % 3600000) / 60000);
  return `Resets in ${hours}h ${mins}m`;
}
